export const Button = `
  <Button 
    label="Send" // String
    onClick={(e) => console.log('clicked button')} // Function
    type='button' // String: button, submit, reset
    color="secondary" // String: default, default-on-dark, primary, primary-on-dark, info, warning, success, danger
    className="override-base-component" // (only when necessary)
    iconLeft={<IconMail size="sm" />} // React node: xs, sm, md base-icon
    isLoading={false} // Boolean (displays loader when true)
    size={"md"} // String: sm, md, lg
  />
`
